import { ErrorHandler, Injectable, Injector } from "@angular/core";

import { ErrorType } from "./error-types.enum";
import { ErrorMessages } from "./error-messages";
import { Router } from "@angular/router";
import { AlertService } from "../../_services/alert.service";

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  public alertService: AlertService;
  public router: Router;

  constructor(private injector: Injector) {}

  public handleError(error: any) {
    // tslint:disable-next-line:no-console
    console.error(error);
    const { errType, message } = this.determineErrorType(error);
    if (message) {
      this.showErrorAsToast(message);
    }
    if (errType === ErrorType.Status_401_Unauthorized) {
      this.router = this.router || this.injector.get(Router);
      setTimeout(() => this.router.navigate(["/login"]), 1000);
    }
  }

  private determineErrorType(error: any): {
    errType: ErrorType;
    message?: string;
  } {
    if (error && error.status) {
      switch (error.status) {
        case ErrorType.Status_504_Gateway_Timout:
          return {
            errType: ErrorType.Status_504_Gateway_Timout,
            message: ErrorMessages.tooLongToRespond,
          };

        case ErrorType.Status_401_Unauthorized:
          return {
            errType: ErrorType.Status_401_Unauthorized,
            message: ErrorMessages.youWereLogedOut,
          };
      }
    }
    return { errType: ErrorType.UnknownError };
  }

  private showErrorAsToast(message: string) {
    this.alertService = this.alertService || this.injector.get(AlertService);
    this.alertService.error(message);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/error-handler/global-error-handler.ts